import store from '@/store';
import router from '@/router/index';

import api from '@/services/api';

import session from '@/services/api/compte/session';
import { obtenirSiteIds } from '@/services/api/compte/sites';
import profile from '@/services/api/compte/profile';
import { PageMapping } from '@/helpers/PageMappingHelpers';
import {
  isProductSourceInQueryParams,
  getProductSourceFromQueryParams,
  ProductSourceInfo,
  isProductSource2eChance,
} from '@/helpers/ProductSourceHelpers';

import i18n from '@/js/i18n';

export default {
  // TODO: Doit retourner une valeur car appeler comme une tâche
  async seConnecter() {
    const state = store.state.compte;
    const errorUrl = PageMapping.ERREUR_GENERIQUE.siteUrl;
    if (state.nomUtilisateur === '' || state.motDePasse === '') {
      const msg = i18n.t('compte.connexion.erreurInvalidLogin');
      afficherMessageErreurLogin(msg);
      throw new Error('CONNEXION');
    }

    await session
      .ouvrirSession(state.nomUtilisateur, state.motDePasse)
      .then(async () => {
        await profile
          .getProfileUpdateStatusSeen()
          .then((response) => {
            if (response.data.ProfileUpdateStatus !== 'CONFIRMED') {
              if (response.data.ProfileUpdateStatus === 'SEEN') {
                // seen=true et transformé en info-pers=1
                router.push({ query: { 'info-pers': 1 } });
              }
              throw { url: PageMapping.CANAFE_CONFIRMATION.siteUrl };
            } else {
              retourConnexion();
            }
          })
          .catch((error) => {
            retourConnexion();
          });
      })
      .catch((error) => {
        if (error.url) {
          throw error;
        } else if (error.message === 'CONNEXION') {
          // eslint-disable-next-line no-useless-catch
          try {
            if (isProductSource2eChance()) {
              // eslint-disable-next-line no-undef
              const autoExclu = ejApi.isAutoExclu();
              // eslint-disable-next-line no-undef
              const enPauseDeJeu = ejApi.isEnPauseDeJeu();
              // eslint-disable-next-line no-undef
              const estInvite = ejApi.clientEstInvite();

              if (estInvite && autoExclu) {
                // On redirige un compte GUEST vers la validation d'identité
                throw { url: PageMapping.IDENTITE_REPRISE.siteUrl };
              }
              if (autoExclu || enPauseDeJeu) {
                // On redirige les clients 2e chance (autoexclus/pause de jeu) vers la page COMPTE_BLOQUE_2E_CHANCE
                throw { url: PageMapping.COMPTE_BLOQUE_2E_CHANCE.siteUrl };
              }
            }
            // Sur une connexion on utilise le composant "MessageMel" pour afficher l'erreur
            throw error;
          } catch (error) {
            throw error;
          }
        } else {
          const message = api.processError(error);
          store.commit('message/ADD_MESSAGE_FLASH', message);
          throw { url: errorUrl };
        }
      });
  },

  async seDeconnecter() {
    await session
      .fermerSession()
      .then(() => {})
      .catch((error) => {
        const message = api.processError(error);
        store.commit('message/ADD_MESSAGE_FLASH', message);

        throw { url: PageMapping.ERREUR_GENERIQUE.siteUrl };
      });
  },
};

function afficherMessageErreurLogin(msg) {
  const span = document.getElementById('zoneMessageErreurLogin');
  span.textContent = msg;
}

function retourConnexion() {
  /**
   * 2021-09-29 - Nouvelles règles fonctionnelles
   * Jira : SWSPC-1765 (https://lotoquebec.atlassian.net/browse/SWSPC-1765)
   */
  // eslint-disable-next-line no-useless-catch
  try {
    if (getProductSourceFromQueryParams()) {
      // eslint-disable-next-line no-undef
      const estInvite = ejApi.clientEstInvite();
      // var estInvite = ejConnect.etatClient && ejConnect.etatClient === "ci";
      if (isProductSourceInQueryParams([ProductSourceInfo.PR, ProductSourceInfo.PS]) && estInvite) {
        redirigerVersURLRetourConnexion();
      } else if (!estInvite) {
        redirigerVersURLRetourConnexion();
      }
    } else {
      // L'aiguillage se fera automatiquement
      throw { url: PageMapping.IDENTITE_REPRISE.siteUrl };
    }
  } catch (error) {
    throw error;
  }
}

function redirigerVersURLRetourConnexion() {
  obtenirSiteIds()
    .then((response) => {
      if (response && response.data.URLRetourConnexion) {
        window.location.href = response.data.URLRetourConnexion;
      } else {
        throw { url: PageMapping.IDENTITE_REPRISE.siteUrl };
      }
    })
    .catch((error) => {
      if (error.url) {
        throw error.url;
      }
      throw { url: PageMapping.ERREUR_GENERIQUE.siteUrl };
    });
}
